import { inject, Injectable } from '@angular/core';
import { RoamingRepository } from '@data/repositories/roaming.repository';
import { environment } from '@environments/environment';
import { HttpService } from '@shared/services.http';
import { GetRoamingHoursDto, GetRoamingHoursResp } from '@usecase/roaming/get-roaming-hours/get-roaming-hours.type';
import { GetRoamingPageDataResp } from '@usecase/roaming/get-roaming-page-data/get-roaming-page-data.type';
import { Observable } from 'rxjs';

@Injectable({
    providedIn:'root'
})

export class RoamingAdapter extends RoamingRepository {
    http = inject(HttpService);

    GetRoamingPageData(): Observable<GetRoamingPageDataResp> {
        return this.http.get(`${environment.serviceApi}read/v2/wec/store-page/checkout`, {});    
    }
    GetRoamingHours(payload: GetRoamingHoursDto): Observable<GetRoamingHoursResp> {
        return this.http.post(`${environment.serviceApi}store/product/roaming-hour-list`, payload);
    }
}